"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paletteValueToHueStepTuple = void 0;
var _paletteValueToTuple2 = require("./paletteValueToTuple");
const HUE_STEP_REGEX = /[a-z]+|[^a-z]+/gi;
const paletteValueToHueStepTuple = paletteValue => {
  var _alias$match;
  const _paletteValueToTuple = (0, _paletteValueToTuple2.paletteValueToTuple)(paletteValue),
    alias = _paletteValueToTuple[0];
  const _ref = (_alias$match = alias.match(HUE_STEP_REGEX)) !== null && _alias$match !== void 0 ? _alias$match : [],
    hue = _ref[0],
    step = _ref[1];
  if (hue && step) return [hue, Number(step)];
  return ['gray', 100];
};
exports.paletteValueToHueStepTuple = paletteValueToHueStepTuple;